import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRent = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	width: "16px",
	height: "16px",
	viewBox: "0 0 16 16",
	style: { enableBackground: "new 0 0 16 16" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.st0{fill-rule:evenodd;clip-rule:evenodd;}\n"
	}), /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
		className: "st0",
		d: "M12.24,1.41V0h-0.94v1.41H4.71V0H3.76v1.41H0V16h16V1.41H12.24z M15.06,15.06H0.94V5.65h14.12V15.06z  M15.06,4.71H0.94V2.35h2.82v1.41h0.94V2.35h6.59v1.41h0.94V2.35h2.82V4.71z"
	}), /* @__PURE__ */ _jsx("path", {
		className: "st0",
		d: "M5.33,13.01H6.2v-0.82h0.79v-0.66h0.76V10.8h0.68l0.43-0.43c0.21,0.09,0.43,0.14,0.67,0.14 c0.94,0,1.7-0.76,1.7-1.7c0-0.94-0.76-1.7-1.7-1.7c-0.94,0-1.7,0.76-1.7,1.7c0,0.24,0.05,0.46,0.14,0.67l-3.54,3.54v0.9h0.9V13.01z  M9.87,8.01c0.26,0,0.47,0.21,0.47,0.47c0,0.26-0.21,0.47-0.47,0.47c-0.26,0-0.47-0.21-0.47-0.47C9.4,8.22,9.61,8.01,9.87,8.01z"
	})] })]
});
export default SvgRent;
